import AttributeNode from '../core/AttributeNode.js';

class UVNode extends AttributeNode {
  constructor() {
    let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    super(null, 'vec2');
    this.index = index;
  }

  getAttributeName() {
    const index = this.index;
    return 'uv' + (index > 0 ? index + 1 : '');
  }

  serialize(data) {
    super.serialize(data);
    data.index = this.index;
  }

  deserialize(data) {
    super.deserialize(data);
    this.index = data.index;
  }

}

UVNode.prototype.isUVNode = true;
export default UVNode;